/** URL `?tab=` values for petty work overview. */
export const PettyWorkOverviewTabParam = {
  OVERVIEW: "overview",
  LINE_ITEMS: "line-items",
  MATERIAL_REQUESTS: "material-requests",
} as const;

export type PettyWorkOverviewTabParamValue =
  (typeof PettyWorkOverviewTabParam)[keyof typeof PettyWorkOverviewTabParam];

const TAB_ID_TO_PARAM: Record<string, PettyWorkOverviewTabParamValue> = {
  "1": PettyWorkOverviewTabParam.OVERVIEW,
  "2": PettyWorkOverviewTabParam.LINE_ITEMS,
  "3": PettyWorkOverviewTabParam.MATERIAL_REQUESTS,
};

const PARAM_TO_TAB_ID: Record<string, string> = {
  [PettyWorkOverviewTabParam.OVERVIEW]: "1",
  [PettyWorkOverviewTabParam.LINE_ITEMS]: "2",
  [PettyWorkOverviewTabParam.MATERIAL_REQUESTS]: "3",
};

export function pettyWorkOverviewTabIdFromSearchParam(tab: string | null): string {
  if (!tab) return "1";
  return PARAM_TO_TAB_ID[tab] ?? "1";
}

export function searchParamForPettyWorkOverviewTabId(
  tabId: string,
): PettyWorkOverviewTabParamValue | null {
  return TAB_ID_TO_PARAM[tabId] ?? null;
}

export function isValidPettyWorkOverviewTabParam(tab: string | null): boolean {
  if (!tab) return false;
  return Object.prototype.hasOwnProperty.call(PARAM_TO_TAB_ID, tab);
}
